<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.modules.product.title'
      :titleIcon='$store.state.icons.modules.product.icon'
      :titleIconColor='$store.state.icons.modules.product.color'
    >
      <template v-slot:toolbarButtons>
        <v-btn small color='primary' width='76px' depressed @click='openProducts()'>
          <v-icon small left>mdi-plus</v-icon>
          {{ product.length ? 'Edit' : 'Add' }}
        </v-btn>
      </template>
      <v-simple-table outlined dense>
        <tbody>
          <tr v-if='!product.length'>
            <td class='text-left grey--text'>None...</td>
          </tr>
          <tr v-else v-for='(entry, index) in product' :key='index'>
            <td class='text-left pr-0'>
              {{ entry.qty + ' - ' + entry.product_obj.description + (entry.is_warranty ? ' (wrty)' : '') }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

  <!-- PRODUCT DIALOG -->
    <wc-dialog
      :showDialog='showProductDialog'
      title='Edit Product'
      hideButtons
      :fullscreen="true"
    >
      <template v-slot:toolbarButtons>
        <v-btn small elevation='0' color="error lighten-1" @click="showProductDialog=false" style="margin-right: 25px">Cancel</v-btn>
        <v-btn small elevation='0' color='primary lighten-1' @click='updateProduct()'>Save</v-btn>
      </template>
      <v-form v-model='isFormValid'>
        <div v-for='(item, index) in productList' :key='index'>
          <v-row>
            <v-col cols='4'>
              <div>
                <h3 class='font-weight-bold'>{{ item.description }}</h3>
                <h3 class='caption'>{{ 'Non Warranty: ' + getQty(item, false) }}</h3>
                <h3 class='caption'>{{ 'Warranty: ' + getQty(item, true) }}</h3>
              </div>
            </v-col> 
            <v-col cols='4'>
                <v-text-field 
                    label="Warranty Qty"
                    outlined
                    @input="editWarrantyQty(item, $event)"
                    persistent-placeholder
                    :placeholder="getQty(item, true)" />
            </v-col>
            <v-col cols='4'>
                <v-text-field
                label="Non Warranty Qty"
                outlined
                @input="editNonWarrantyQty(item, $event)"
                persistent-placeholder
                :placeholder="getQty(item, false)"/>
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </div>
      </v-form>
      <template v-slot:fullWidth>
        <v-card-actions>
          <v-btn block depressed color='primary' @click='updateProduct()'>Save</v-btn>
        </v-card-actions>
      </template>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'fc-product',
  props: {
    wo: {
      required: true
    },
    productList: {
      required: true
    },
    product: {
      required: true
    },
  },
  data: () => ({
    isFormValid: false,
    showProductDialog: false,
    productCopy: [],
  }),
  computed: {
   
  },
  methods: {
    openProducts () {
      this.productCopy = _.cloneDeep(this.product)
      this.showProductDialog = true
    },
    updateProduct () {
      this.$emit('updateProduct', this.productCopy)
      this.showProductDialog = false
    },
    editNonWarrantyQty(item, value) {
      let tmp = _.find(this.productCopy, function(o) { return o.product === item.id && o.is_warranty === false});
      if (!tmp) {
        let prod = {};
        prod.product = item.id;
        prod.is_warranty = false;
        prod.work_order = this.wo.id;
        prod.added_by = this.$store.state.auth.profile.id;
        prod.qty = value;
        this.productCopy.push(prod);
      } else {
        if (value === "0") {
          let index = this.productCopy.indexOf(tmp);
          this.productCopy.splice(index, 1);
        }
        else{
            tmp.qty = value;
        }
      }
    },
    editWarrantyQty(item, value) {
      let tmp = _.find(this.productCopy, function(o) { return o.product === item.id && o.is_warranty === true});
      if (!tmp) {
        let prod = {};
        prod.product = item.id;
        prod.is_warranty = true;
        prod.work_order = this.wo.id;
        prod.added_by = this.$store.state.auth.profile.id;
        prod.qty = value;
        this.productCopy.push(prod);
      } else {
        if (value === "0") {
          let index = this.productCopy.indexOf(tmp);
          this.productCopy.splice(index, 1);
        }
        else{
            tmp.qty = value;
        }
      }
    },
    getQty (item, isWarranty) {
      let tmp = _.find(this.productCopy, function(o) { return o.product === item.id && o.is_warranty === isWarranty; })
      return tmp ? tmp.qty.toString() : "0"
    }
  }
}
</script>

<style scoped>

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top:  0;
  z-index: 5;
}

</style>